import React from 'react';
import { CheckCircle } from 'lucide-react';
interface PurchaseNotificationProps {
  name: string;
  city: string;
  isVisible: boolean;
}
export function PurchaseNotification({
  name,
  city,
  isVisible
}: PurchaseNotificationProps) {
  return <div className={`fixed left-4 z-30 transform transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'} 
      bottom-4`} data-id="element-10">
      <div className="bg-[#0a1120] rounded-xl p-4 flex items-center gap-3 border-2 border-orange-500 shadow-xl max-w-sm" data-id="element-11">
        <div className="bg-orange-500/20 p-2 rounded-full flex-shrink-0" data-id="element-12">
          <CheckCircle className="w-6 h-6 text-orange-500" data-id="element-13" />
        </div>
        <div data-id="element-14">
          <p className="text-sm font-bold text-white" data-id="element-15">
            <span className="text-orange-400" data-id="element-16">{name}</span> de{' '}
            <span className="text-orange-400" data-id="element-17">{city}</span>
          </p>
          <p className="text-xs text-gray-300 font-medium mt-0.5" data-id="element-18">
            acaba de acceder al sistema PLC MASTER
          </p>
          <p className="text-[10px] text-gray-500 mt-1" data-id="element-19">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}